export const parseJson = json => {
  try {
    if (json) return JSON.parse(json);
    else throw 'Không thể parse';
  } catch {
    return json;
  }
};
